import { PrebidModule } from 'features/globalSetup/types/prebidModule'
import { PrebidModuleDTO } from '../types/prebidModule'

export const demandToAccount = (demand: PrebidModuleDTO['demand']): PrebidModule['account'] =>
  demand ? 'yieldbird' : 'own'
